import React from 'react'
import { KTSVG } from '../../../../_metronic/helpers'

type Props = {
  setSearchText: React.Dispatch<React.SetStateAction<string>>
}

const CustomerSearch:React.FC<Props> = ({setSearchText}) => {
  return (
    <div className='col-md-12 justify-content-end p-0'>
            <form className='position-relative' autoComplete='off'>
              <input
                type='text'
                className='form-control form-control-solid px-15 w-100'
                name='search'
                placeholder='Arama'
                onChange={(e) => setSearchText(e.target.value)}
              />
              <KTSVG
                path='/media/icons/duotone/General/Search.svg'
                className='svg-icon-2 svg-icon-lg-1 svg-icon-gray-500 position-absolute top-50 ms-5 translate-middle-y'
              />
            </form>
    </div>
  )
}

export default CustomerSearch
